import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { getFormattedAdPrice } from 'SRC/utils'

const Price = ({ price, is_price_shown, priceWithDiscount, availability, isMobileDevice }) => {
  return (
    <div className={'oglasi-items-tekst-cena'} style={{ marginBottom: '5px' }}>
      {!is_price_shown || !Number(price) ? (
        <div className={!isMobileDevice ? 'cena' : 'cena-mobile'}>
          <p>Cijena na upit</p>
        </div>
      ) : (
        <div className={!isMobileDevice ? 'cena' : 'cena-mobile'}>
          <p>{getFormattedAdPrice(priceWithDiscount || price)} &euro;</p>
        </div>
      )}

      {is_price_shown && priceWithDiscount && price ? (
        <span className={`stara-cena${!isMobileDevice ? ' stara-cena-mobile' : ''}`}>{getFormattedAdPrice(price)} &euro;</span>
      ) : null}
    </div >
  )
}

Price.propTypes = {
  price: PropTypes.number.isRequired,
  oldPrice: PropTypes.number,
  is_price_shown: PropTypes.bool.isRequired,
  availability: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  }).isRequired,
  isMobileDevice: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  isMobileDevice: getIsMobileDevice(state)
})

export default connect(mapStateToProps)(Price)

